import { Grid, Typography } from "@mui/material"

export const InfoBox = () => {
  return (
    <Grid item xs={12} sx={{ maxHeight: "150px", overflowY: "scroll" }}>
      <Typography variant="body2">
        <b>SEARCH ON DIFFERENT THINGS</b> you must choose what you need to search on using the bar
        along the top (default is node name), so you can find all 'deterministic' nodes using type,
        or all nodes in the group, or all nodes with a certain unit etc.
      </Typography>
      <Typography variant="body2">
        <b>MULTIPLE TERMS</b> you can enter multiple terms, not necessarily connected together
      </Typography>
      <Typography variant="body2">
        <b>AT-START</b> if you need to match something at the start of the node name you can use ^,
        e.g. ^USA
      </Typography>
      <Typography variant="body2">
        <b>AT-END</b> Similarly, to match something at the end of the node name use $, e.g. USA
        price$
      </Typography>
      <Typography variant="body2">
        <b>EXCLUSION</b> To exclude a match use !, e.g. CAN industry !diff !lag1 e.g. pct change
        !USA
      </Typography>
    </Grid>
  )
}
